<template>
  <div>
    <h5>{{ $t('Mensajes') }}</h5>
    <p>{{ $t('No hay mensajes') }}.</p>
  </div>
</template>

<i18n>
  {
    "es": {
      "Mensajes": "Mensajes",
      "No hay mensajes": "No hay mensajes"
    },
    "en": {
      "Mensajes": "Messages",
      "No hay mensajes": "There are no messages"
    }
  }
</i18n>

<script>
  export default {
    
  }
</script>
